
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/team-standings/[conference]",
      function () {
        return require("private-next-pages/[league]/team-standings/[conference]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/team-standings/[conference]"])
      });
    }
  